import {
  AllocateOrderInventoryCompletedMessage,
  FileImportCompleteMessage,
} from '../../types';
import type { RootState } from '../types';

const EMPTY_OBJECT: Record<string, never> = {};

export const uiSelectors = {
  viewVersion: (state: RootState) => state.ui.viewVersion,
  listLoading: (state: RootState) => state.ui.listLoading,
  isSidebarOpen: (state: RootState) => state.ui.isSidebarOpen,
  alerts: (state: RootState) =>
    (state.ui.alerts || EMPTY_OBJECT) as {
      [id: string | number]: Record<string, any>;
    },
  shipmentLoadGuid: (state: RootState) => state.ui.shipmentLoadGuid,
  appointmentStatusChangedAlertGuid: (state: RootState) =>
    state.ui.appointmentStatusChangedAlertGuid,
  appointmentUnloadedAlertGuid: (state: RootState) =>
    state.ui.appointmentUnloadedAlertGuid,
  driverCheckInAlertGuid: (state: RootState) => state.ui.driverCheckInAlertGuid,
  smallParcelAlertGuid: (state: RootState) => state.ui.smallParcelAlertGuid,
  freightAlertGuid: (state: RootState) => state.ui.freightAlertGuid,
  pickJobAllocationChangeAlertGuid: (state: RootState) =>
    state.ui.pickJobAllocationChangeAlertGuid,
  inventoryTransferStatusChangeAlertGuid: (state: RootState) =>
    state.ui.inventoryTransferStatusChangeAlertGuid,
  receiptImportCompleteAlertPayload: (state: RootState) =>
    state.receipts.receiptImportCompleteAlertPayload,
  orderImportCompleteAlertPayload: (state: RootState) =>
    state.orders
      .orderImportCompleteAlertPayload as FileImportCompleteMessage | null,
  allocateOrderInventoryCompletedPayload: (state: RootState) =>
    state.orders
      .allocateOrderInventoryCompletedPayload as AllocateOrderInventoryCompletedMessage | null,
  showTimer: (state: RootState) => state.ui.showTimer,
  cameraEntityConfig: (state: RootState) => state.ui.cameraEntityConfig,
};
